import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { LanguageCode } from '../enums';

export const useLanguage = () => {
  const { i18n } = useTranslation();

  const language = useMemo(
    () => i18n.resolvedLanguage as LanguageCode,
    [i18n.resolvedLanguage],
  );

  const changeLanguage = useCallback(
    async (code: LanguageCode) => {
      await i18n.changeLanguage(code);
    },
    [i18n],
  );

  return {
    language,
    changeLanguage,
  };
};
